"use client";

import { Pagination } from "swiper/modules";
import { useRouter } from "next/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
//
import { Collapse } from "@/components";
import { getImageURL, useSwiperSliderOptions, sanitizeHTML } from "@/lib";

export const HomePageWaree = ({ data = {}, slug = "group-sites" }) => {
  let { list } = data;

  const { sliderButtons, nextSlide, prevSlide, options } =
    useSwiperSliderOptions({
      slidesPerView: 5,
      modules: [Pagination],
      pagination: {
        clickable: true,
      },
      loop: true,
      loopAdditionalSlides: 2,
      centeredSlides: true,
      roundLengths: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        575: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
        1400: {
          slidesPerView: 5,
        },
      },
    });

  if (list?.length < 4) {
    list = [...list, ...list, ...list];
  }
  // loop additional because NO DATA IN BACKEND!!
  else if (list?.length < 8) {
    list = [...list, ...list];
  }

  const routes = useRouter();

  const OpenUrl = (url) => {
    if (url?.startsWith("http")) {
      window.open(url, "_blank");
    } else {
      routes.push(url);
    }
  };

  return (
    <section className="waree__section" id={slug}>
      <div className="custom-container">
        <div className="row">
          <div className="col-12">
            <div className="solar__area_wrapper">
              <Swiper {...options} className="solar__area_slider">
                {list?.map((item, index) => (
                  <SwiperSlide key={index}>
                    {({ isActive }) => (
                      <div className="item_wrap">
                        <div
                          className={`single__item ${isActive ? "active" : ""}`}
                        >
                          <div className="header d-flex">
                            {/* <div className="heading fs-20 fw-600">
                                                            {item?.title}
                                                        </div> */}
                            <div className="img_wrap">
                              <img src={getImageURL(item?.icon?.src)} />
                            </div>
                            <div className="icon_wrap">
                              <a
                                href={item?.link?.url || "#"}
                                onClick={(e) => {
                                  e.preventDefault();
                                  OpenUrl(item?.link?.url);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={50}
                                  height={16}
                                  viewBox="0 0 50 16"
                                  fill="none"
                                >
                                  <path
                                    d="M49.7071 8.70711C50.0976 8.31658 50.0976 7.68342 49.7071 7.29289L43.3431 0.928932C42.9526 0.538408 42.3195 0.538408 41.9289 0.928932C41.5384 1.31946 41.5384 1.95262 41.9289 2.34315L47.5858 8L41.9289 13.6569C41.5384 14.0474 41.5384 14.6805 41.9289 15.0711C42.3195 15.4616 42.9526 15.4616 43.3431 15.0711L49.7071 8.70711ZM0 8V9H49V8V7H0V8Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </a>
                            </div>
                          </div>

                          <Collapse show={isActive}>
                            <div
                              className={`content_wrap text-white active ${
                                isActive ? "active" : ""
                              }`}
                            >
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: sanitizeHTML(item?.description),
                                }}
                              />
                            </div>
                          </Collapse>
                        </div>
                      </div>
                    )}
                  </SwiperSlide>
                ))}
                {/* <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                                    {data?.list?.map((item, index) => (
                                        <span
                                            key={index}
                                            className={`swiper-pagination-bullet ${
                                                index ===
                                                sliderButtons?.activeIndex
                                                    ? "swiper-pagination-bullet-active"
                                                    : ""
                                            }`}
                                        />
                                    ))}
                                </div> */}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
